import { useMemo } from 'react';
import { GetLevelByColumnValueFn } from 'libs/end-to-end/src/dimension';
import { BasicCopilotOutputState } from 'apps/sigma2-ui/src/copilot/types/BasicCopilotOutputState';
import { SlatePoolSubject } from 'libs/end-to-end/src/copilot';
import { createSlatePoolSubjectsFromOutput } from 'libs/end-to-end/src/copilot-utils';

export const useBasicCopilotSubjectsWithSlateStatus = ({
  currentState,
  getLevelByColumnValue,
  selectedSlateIds,
}: {
  currentState: BasicCopilotOutputState;
  getLevelByColumnValue: GetLevelByColumnValueFn;
  selectedSlateIds: string[];
}): SlatePoolSubject[] => {
  return useMemo(() => {
    if (currentState.state !== 'success') {
      return [];
    }
    return createSlatePoolSubjectsFromOutput(
      currentState.output,
      getLevelByColumnValue,
      selectedSlateIds,
    );
  }, [currentState, getLevelByColumnValue, selectedSlateIds]);
};
